var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConvertshape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 15.3208V17.4808C11.2 19.2808 10.48 20.0008 8.68 20.0008H6.52C4.72 20.0008 4 19.2808 4 17.4808V15.3208C4 13.5208 4.72 12.8008 6.52 12.8008H8.68C10.48 12.8008 11.2 13.5208 11.2 15.3208Z",
    fill: "#8494AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4008 11.2C18.389 11.2 20.0008 9.58822 20.0008 7.6C20.0008 5.61178 18.389 4 16.4008 4C14.4125 4 12.8008 5.61178 12.8008 7.6C12.8008 9.58822 14.4125 11.2 16.4008 11.2Z",
    fill: "#8494AE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.222 20.0012C14.006 20.0012 13.806 19.8812 13.702 19.6972C13.598 19.5052 13.598 19.2812 13.71 19.0892L14.486 17.7932C14.654 17.5052 15.022 17.4172 15.31 17.5852C15.598 17.7532 15.686 18.1212 15.518 18.4092L15.374 18.6492C17.35 18.1372 18.806 16.3452 18.806 14.2172C18.806 13.8892 19.078 13.6172 19.406 13.6172C19.734 13.6172 19.998 13.8892 19.998 14.2252C19.998 17.4092 17.406 20.0012 14.222 20.0012Z",
    fill: "#8494AE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6 10.376C4.272 10.376 4 10.112 4 9.776C4 6.592 6.592 4 9.776 4C10 4 10.192 4.12 10.304 4.304C10.408 4.496 10.408 4.72 10.296 4.912L9.52 6.2C9.344 6.488 8.976 6.584 8.696 6.408C8.408 6.24 8.32 5.872 8.488 5.584L8.632 5.344C6.664 5.856 5.2 7.648 5.2 9.776C5.2 10.112 4.928 10.376 4.6 10.376Z",
    fill: "#8494AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertshape);
export default __webpack_public_path__ + "static/media/convertshape.e6a6fae131c454d1f2672a4b403b963a.svg";
export { ForwardRef as ReactComponent };